import { render, staticRenderFns } from "./tangga_berjalan.vue?vue&type=template&id=76045fbf&"
import script from "./tangga_berjalan.vue?vue&type=script&lang=js&"
export * from "./tangga_berjalan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports